import appearancePalette from './appearancePalette.json';
import photonPalette from '@photon/chat-react/photon-palette';

export const COLOR_SCHEMES = [
  { value: 'photon', label: 'Ultraviolet', primary: photonPalette.light.primary, secondary: photonPalette.light.gradientEnd, palette: photonPalette },
  { value: 'docs', label: 'Spectral', primary: appearancePalette.light.primary, secondary: appearancePalette.dark.primary, palette: appearancePalette },
];

export const getColorSchemePalette = (scheme, mode) => COLOR_SCHEMES.find(entry => entry.value === scheme).palette[mode];